module.exports = __webpack_public_path__ + "static/homepage-desktop-bt-923da0a9ac571de08ecef4f605d7ee7f.jpg";